import React, { useState,useRef,useEffect } from 'react';
import {Form,Button,Table,Input,InputNumber,message} from 'antd';
import QualityList from '../components/QualityList';
import ProductListModal from '../components/ProductList';
import { Space } from 'antd';
import './index.less';
import { useParams,useHistory} from 'react-router-dom';
import {saveQualityGradient,getQualityGradientInfo} from '../util/api';
const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 10 },
};

const QualityGradientDetail = ()=>{
  const [form] = Form.useForm();
  const ref = useRef(null);
  const params = useParams();
  const history = useHistory();
  const [productList,setproductList] = useState([]);
  const [open,setOpen] = useState(false);
  const validateInput = (_, value) => {
    const intValue = parseInt(value, 10);
    if (intValue > 0 && Number.isInteger(intValue)) {
      return Promise.resolve();
    }
    if (intValue > 100) {
      return Promise.reject(new Error('请输入小于等于100的整数'));
    }
    return Promise.reject(new Error('请输入大于0的整数'));
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getQualityGradientInfo({ id: params?.id });
        const { data, code, msg } = result.data || {};
  
        if (code === 0) {
          const { name, abnormal_prop, products = [], gradient = [] } = data || {};
  
          setproductList(products);
  
          const gradientData = gradient.map((item, index) => ({
            ...item,
            key: index + 1,
          }));
  
  
          ref.current.setData(gradientData);
          ref.current.setCount(gradient.length);
  
          const initialValues = {};
          gradient.forEach((item, i) => {
            initialValues[`high[${i + 1}]`] = item.high;
            initialValues[`rate[${i + 1}]`] = item.rate;
          });
  
          form.setFieldsValue({
            name,
            abnormal_prop,
            ...initialValues,
          });
        } else {
          message.error(msg);
        }
      } catch (error) {
        console.error(error);
        // 处理错误
      }
    };
  
    if (params?.id) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const columns = [
    { title: '商品分类', key: 'category_list', dataIndex: 'category_list', align: 'center', },
    { title: 'SKU编码', key: 'sku_no', dataIndex: 'sku_no', align: 'center', },
    { title: '商品名称', key: 'sale_name', dataIndex: 'sale_name', align: 'center', },
    { title: 'ITEM单位', key: 'item_unit', dataIndex: 'item_unit', align: 'center', },
    {
      title:'操作',
      dataIndex:'op',
      align:'center',
      render: (_, record) => {
        return (
          <>
            <a
              className="custom-options-title"
              onClick={() => deleteItem(record)}
            >
              删除
            </a>
          </>
        );
      },
    },
  ];
  const deleteItem = (record) => {
    let newArr = productList.filter((item) => {
      return item.sku_no !== record.sku_no;
    });
    setproductList(newArr);
  };
  const handleValidation = async () => {
    try {
      const result = await form.validateFields();
      const {name,abnormal_prop,} = result || {};
     const data = ref?.current?.data || [];
      const res = await saveQualityGradient({
        name,
        id:params?.id,
        abnormal_prop,
        products:productList,
        gradient:data
      });
      const {msg,code} = res.data || {};
      if(code === 0){
        message.success(msg);
        history.push('/basic/user/qualityGradient');
      }else{
        message.error(msg);
      }
    } catch (error) {
      // 处理错误
    }
  };

  const onFinish = (values) => {
    console.log(ref.current.data);
    handleValidation();
  };
  const handleOpenProduct = ()=>{
    setOpen(true);
  };
  const handleCancel = () => setOpen(false);
  const handleProduct = (data) => {
    const updatedProductList = [...productList];
    data.forEach((item) => {
      if (!updatedProductList.some((product) => product.sku_no === item.sku_no)) {
        updatedProductList.push(item);
      }
    });

    setproductList(updatedProductList);
    setOpen(false);
  };

  return (
    <>
      <div style={{display:'flex',fontSize:'20px',fontWeight:'500',margin:'10px 0',}}>
        <span style={{textDecoration:'underline',cursor:'pointer',color:'#1890FF',}} onClick={()=>history.go(-1)}>抽检梯度</span><span>/详情页</span>
      </div>
      <Form {...layout} form={form} name="quality"  onFinish={onFinish}>
            <Form.Item
              label="梯度规则名称"
              name='name'
              rules={[{ required: true, message: '请输入梯度规则名称' }]}
              >
              <Input />
            </Form.Item>
            <Form.Item label='商品明细'>
              <Button type='primary' onClick={handleOpenProduct}>添加商品</Button>
            </Form.Item>
            <Table
            columns={columns}
            rowKey={'sku_no'}
            className='quality-table-cell'
            dataSource={productList}
            style={{margin:'10px 10px'}}/>
            <Form.Item
            label='异常占比'
            name='abnormal_prop'
            validateFirst={true}
            tooltip="用于比较移动端质检商品的不合格占比"
            rules={[
              { required: true, message: '请输入比值' },
              {
                validator: validateInput,
              },
            ]}
            >
             <InputNumber addonAfter="%" min={1} max={100} placeholder='请输入比值'/>
            </Form.Item>

            <Form.Item
            label='抽检梯度'
            className='labelCol'
            wrapperCol={{span:18}}
            >
              <QualityList form={form} ref={ref}  />
            </Form.Item>
            <Form.Item wrapperCol={{span:12,offset:10}}>
              <Space >
                  <Button type='primary' htmlType="submit">确定</Button>
                  <Button onClick={()=>history.go(-1)}>取消</Button>
              </Space>
            </Form.Item>
      </Form>
      {
          open &&<ProductListModal type={1} handleProduct={handleProduct} handleCancel={handleCancel} />
        }
    </>
  );
};


export default QualityGradientDetail;